import { MoonIcon, SunIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { themeStore, useTheme } from '@/lib/theme';
import { strings } from '@/i18n/strings';

/**
 * Yorug'/qorong'i mavzu.
 *
 * Efir kechqurun o'tkaziladi va konsol o'sha paytda soatlab ochiq turadi — qorong'i mavzu bu
 * yerda bezak emas, ish sharoiti.
 */
export function ThemeToggle({ className }: { className?: string }) {
  const theme = useTheme();
  const label = theme === 'dark' ? strings.shell.themeToLight : strings.shell.themeToDark;

  return (
    <Button
      variant="ghost"
      size="icon-sm"
      className={className}
      aria-label={label}
      title={label}
      onClick={() => themeStore.toggle()}
    >
      {theme === 'dark' ? <SunIcon aria-hidden="true" /> : <MoonIcon aria-hidden="true" />}
    </Button>
  );
}
